/*****************************************************************************
 * cmnUtil(共通ユーティリティ)
 ****************************************************************************/
// 共通で使用するJSオブジェクト
const cmnUtil = {
    fadeInTargets: null,
    scrollY: 0,
};

/**
 * 要素のoffset値取得
 * @param {element} el html要素 
 * @returns 要素のoffset値(top,left)
 */
cmnUtil.getOffset = function (el) {
    const box = el.getBoundingClientRect();

    return {
        top: box.top + window.pageYOffset - document.documentElement.clientTop,
        left: box.left + window.pageXOffset - document.documentElement.clientLeft
    }
}

/**
 * 画面スクロール時のフェードインEvent設定
 */
cmnUtil.onScrollfadeIn = function () {

    // スクロール対象の要素を取得
    cmnUtil.fadeInTargets = Array.prototype.slice.call(document.getElementsByClassName('jsScroll'));

    // スクロールイベントを設定
    window.addEventListener("scroll", function () {
        cmnUtil.handleScroll();
    });
}

/** 
 * スクロールイベント発生時処理
 */
cmnUtil.handleScroll = function () {

    /** フェードイン */
    if (!cmnUtil.fadeInTargets || cmnUtil.fadeInTargets.length === 0) {
        return;
    }
    const scroll = window.pageYOffset || document.documentElement.scrollTop; // 現在のスクロール位置
    const windowHeight = window.innerHeight; // 現在のブラウザの高さ

    let elem = null;
    let newList = [];
    while (typeof (elem = cmnUtil.fadeInTargets.shift()) !== 'undefined') {
        let offset = cmnUtil.getOffset(elem).top;
        if (scroll > offset - windowHeight + 100) {
            elem.classList.add('jsScrollIn');
        } else {
            newList.push(elem);
        }
    }
    cmnUtil.fadeInTargets = newList;
}

/*****************************************************************************
 * アコーディオンコンポーネント(Slide)
 * 初期表示状態あり、リサイズ対応あり
 ****************************************************************************/
Vue.component('js-accordion', {
    template: `
<div class="js-accordion" :id="idname" :class="[{'js-accordion--open': isOpened, 'js-accordion--close': !isOpened}]" v-cloak>
    <div class="js-accordion__trigger" @click.stop="accordionToggle()">
        <slot name="trigger"></slot>
        <span class="js-accordion__icon"></span>
    </div>
    <transition name="js-accordion__target" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="js-accordion__target" v-show="isOpened">
            <slot name="content"></slot>
        </div>
    </transition>
</div>
`,

    props: {
        idname: { // アコーディオン識別ID
            type: String,
            default: ""
        },
        targetClassName: { // 
            type: String,
            default: ""
        },
        isOpenedFirst: { // 初期状態で表示するか否か
            type: Boolean,
            default: false
        }
    },

    data: function () {
        return {
            isOpened: false
        };
    },

    /***************************************************************************
     * 画面初期表示時処理
     **************************************************************************/
    created: function () {

        // リサイズ時高さ再計算
        let self = this;
        let timeout = 0;
        window.addEventListener("resize", function () {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                self.resizeAcdHeight();
            }, 100);
        }, false);

    },

    /***************************************************************************
     * DOM読み込み時処理
     **************************************************************************/
    mounted: function () {
        // 初期状態で開く
        if (this.isOpenedFirst) {
            this.isOpened = true;
        }

        // 初回のサイズ設定
        setTimeout(this.resizeAcdHeight, 500);
    },

    /***************************************************************************
     * 関数
     **************************************************************************/
    methods: {

        /**
         * リサイズ時高さ再計算
         * @returns 
         */
        resizeAcdHeight: function () {

            if (!this.isOpened) {
                return;
            }

            let el = document.querySelector("#" + this.idname + " .js-accordion__target");
            let elInner = document.querySelector("#" + this.idname + " ." + this.targetClassName);
            el.style.height = elInner.scrollHeight + 'px';
        },

        // アコーディオンの表示状態切り替え
        accordionToggle: function () {
            this.isOpened = !this.isOpened;
            // this.$emit('toggle', this.isOpened);
        },


        /**
         * アコーディオンを閉じる
         */
        closeAccordion: function () {
            let self = this;

            // アコーディオン上部にスクロール
            const elem = document.getElementById(self.idname);
            const targetPosition = elem.getBoundingClientRect().top + window.pageYOffset - 70;

            // スクロール位置を設定
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });

            // 時間差でアコーディオンを閉じる
            setTimeout(function () {
                self.isOpened = false;
            }, 500);
        },

        // 表示される前から表示まで
        beforeEnter: function (el) {
            el.style.height = '0px';
        },
        enter: function (el) {
            el.style.height = el.scrollHeight + 'px';
        },

        // 消える前から消えるまで
        beforeLeave: function (el) {
            el.style.height = el.scrollHeight + 'px';
        },
        leave: function (el) {
            el.style.height = '0px';
        }
    }
});

/*****************************************************************************
 * Float コンポーネント
 ****************************************************************************/
Vue.component('js-float', {
    template: `
<div id="floatId" class= "js-float">
    <div :class="[{'js-visible': isVisible, 'js-hide': !isVisible},classname]">
        <slot name="content"></slot>
    </div>
</div>
		`,

    /**
     * 呼び出し元からのデータ
     */
    props: {
        classname: String,
        disabledSectionClass: String, // このセクションが画面の中央より上に表示されたら、非表示にする
        disabledContentClass: String, // このパーツが画面内に表示されたら非表示にする
    },

    /**
     * データ
     */
    data: function () {
        return {
            isVisible: false,
            floatId: '',
        };
    },

    /***************************************************************************
     * 画面初期表示時処理
     **************************************************************************/
    created: function () {
        // スクロールイベントを設定
        window.addEventListener("scroll", this.handleScroll);
    },

    /***************************************************************************
     * DOM読み込み時処理
     **************************************************************************/
    mounted: function () {
        // 表示可能の場合、すぐに表示する
        let self = this;
        setTimeout(function () {
            self.handleScroll();
        }, 100);
    },

    /***************************************************************************
     * 終了時
     **************************************************************************/
    destroyed: function () {
        window.removeEventListener("scroll", this.handleScroll);
    },

    /***************************************************************************
     * 関数
     **************************************************************************/
    methods: {
        /**
         * スクロール時処理
         */
        handleScroll: function () {
            // スクロール位置を取得
            let windowTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
            let windowHeight = window.document.documentElement.clientHeight;
            let windowBottom = windowTop + windowHeight;
            let windowMiddle = (windowTop + windowBottom) / 2;

            // 除外コンテンツが画面に完全に表示されているか否かを判定
            let dispCount = 0;
            let elems = document.getElementsByClassName(this.disabledContentClass);
            for (let i = 0; i < elems.length; i++) {
                let elem = elems[i];
                let elemOffset = cmnUtil.getOffset(elem).top;
                let elemHeight = elem.getBoundingClientRect().height;

                // 対象の要素が表示中
                if (windowTop < elemOffset &&
                    elemOffset + elemHeight < windowTop + windowHeight) {
                    dispCount++;
                }
            }

            // 除外セクションが画面に表示されているか確認
            elems = document.getElementsByClassName(this.disabledSectionClass);
            for (let i = 0; i < elems.length; i++) {
                let elem = elems[i];
                let elemOffset = cmnUtil.getOffset(elem).top;
                let elemHeight = elem.getBoundingClientRect().height;
                let elemBottom = elemOffset + elemHeight;

                // 対象がウィンドウの上に表示中
                if (elemOffset < windowBottom && elemBottom > windowTop) {
                    dispCount++;
                }
            }

            // floatの表示を切り替え
            if (dispCount > 0 || windowTop < 0) {
                // 非表示
                this.isVisible = false;
            } else {
                // 表示
                this.isVisible = true;
            }
        },

    },
});

/*****************************************************************************
 * カルーセルSwiper 
 ****************************************************************************/
Vue.component('swiper', {
    template: `
	<div class="swiper-outer" :class="className">
		<div :id="idName" class="swiper-container">
			<div class="swiper-wrapper">
				<slot name="slides"></slot>
			</div>
			<slot name="option"></slot>
		</div>
		<slot name="outeroption"></slot>
	</div>
	`,

    /**
     * 呼び出し元からのデータ
     */
    props: {
        idName: { // ID
            type: String,
            required: true
        },
        className: { // クラス名(2つ以上Swiperがある場合にデータの識別用)
            type: String,
            default: ""
        },
        dispIndex: { // 表示スライド
            type: Number,
            default: 0
        },
        effect: { // 切り替わり効果(fade, slide など)
            type: String,
            default: "fade"
        },
        fadespeed: { // 切り替わり効果時間
            type: Number,
            default: 500
        },
        autospeed: { // 自動再生のスライド待機時間
            type: Number,
            default: 2500
        },
        isAutoPlay: { // 最初から自動再生するか否か
            type: Boolean,
            default: false
        },
        isLoop: { // Loopするか否か
            type: Boolean,
            default: false
        },
        slidesPerView: { // 左右のはみ出し具合("auto"でCSS定義可能)
            type: String,
            default: "auto"
        },
        slidesPerViewSp: { // 左右のはみ出し具合("auto"でCSS定義可能) SP
            type: String,
            default: "auto"
        },
        centeredSlides: { // 中央寄せ
            type: Boolean,
            default: true,
        },
        centeredSlidesSp: { // 中央寄せ SP
            type: Boolean,
            default: true,
        },
        allowTouchMove: {
            type: Boolean,
            default: true,
        },
        breakPoint: { // このサイズより大きい場合、表示しない
            type: Number,
            default: 9999
        },
        allowTouchMove: { // スワイプ（ドラッグ）可能か否か
            type: Boolean,
            default: true,
        },
    },

    /**
     * データ定義
     */
    data: function () {
        return {
            sw: undefined,
            swiperElement: undefined,
            swiperWrapper: undefined,
            swiperSlide: undefined,
            isSp: true,
        }
    },

    /**
     * 画面初期表示時処理
     */
    mounted: function () {
        this.isSp = window.innerWidth < 768;

        const self = this;
        let resizeTimer = false;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                self.initSwiper();
            }, 100);
        });

        this.initSwiper();
    },

    /**
     * 関数
     */
    methods: {
        /**
         * Swiper初期化
         */
        initSwiper: function () {

            // 要素を取得
            this.swiperElement = document.getElementById(this.idName);
            if (!this.swiperElement) {
                return;
            }
            this.swiperWrapper = this.swiperElement.getElementsByClassName("swiper-wrapper");
            this.swiperSlide = this.swiperElement.getElementsByClassName("swiper-slide");

            // 現在のコンテンツ幅からSP版か判定する
            let screenWidth = window.innerWidth;
            let isSp = screenWidth < 768;

            if (screenWidth > this.breakPoint) { // 表示制限ブレークポイント以上
                // Swiperは表示しない
                if (this.sw != undefined) {
                    this.sw.destroy();
                    this.sw = undefined;
                }
                for (let i = 0; i < this.swiperWrapper.length; i++) {
                    this.swiperWrapper[i].removeAttribute('style');
                }
                for (let i = 0; i < this.swiperSlide.length; i++) {
                    this.swiperSlide[i].removeAttribute('style');
                }

            } else { // 表示制限以下のサイズの場合
                // Swiperのクラス設定
                let appendClass = this.className ? "." + this.className + " " : "";
                let nextClass = appendClass + '.swiper-button-next-lp-frozen-dogfood';
                let prevClass = appendClass + '.swiper-button-prev-lp-frozen-dogfood';
                let pagingClass = appendClass + '.swiper-pagination-lp-frozen-dogfood';

                if (this.isSp != isSp) { // PC/SPの切り替わりの場合、再生成を行う
                    if (this.sw != undefined) {
                        this.sw.destroy();
                        this.sw = undefined;
                    }
                    for (let i = 0; i < this.swiperWrapper.length; i++) {
                        this.swiperWrapper[i].removeAttribute('style');
                    }
                    for (let i = 0; i < this.swiperSlide.length; i++) {
                        this.swiperSlide[i].removeAttribute('style');
                    }
                    this.sw = undefined;
                }

                /** param取得 */
                let fadespeed = Number.parseInt(this.fadespeed);
                let autospeed = Number.parseInt(this.autospeed);
                let slidesPerViewVal = isNaN(this.slidesPerView) ? this.slidesPerView : Number(this.slidesPerView);
                let slidesPerViewValSp = isNaN(this.slidesPerViewSp) ? this.slidesPerViewSp : Number(this.slidesPerViewSp);

                // Swiperを生成する
                if (this.sw == undefined) {
                    this.sw = new Swiper('#' + this.idName, {
                        observer: true,
                        observeParents: true,
                        loop: this.isLoop,
                        centeredSlides: this.centeredSlidesSp,
                        slidesPerView: slidesPerViewValSp,
                        spaceBetween: 0,
                        autoHeight: false,
                        observer: true,
                        observeParents: true,
                        initialSlide: this.dispIndex,
                        effect: this.effect, // 切り替わり効果
                        speed: fadespeed, // 切り替わりスピード
                        allowTouchMove: this.allowTouchMove, // スワイプ（ドラッグ）可能か否か

                        breakpoints: {
                            // スライドの表示枚数：768px以上の場合(PC)
                            768: {
                                centeredSlides: this.centeredSlides,
                                slidesPerView: slidesPerViewVal,
                            },
                        },
                        // 自動再生
                        autoplay: {
                            delay: autospeed,
                            disableOnInteraction: false
                        },

                        // 右左ナビ
                        navigation: {
                            nextEl: nextClass,
                            prevEl: prevClass
                        },

                        // ページアイコン
                        pagination: {
                            el: pagingClass,
                            type: 'bullets',
                            clickable: true,
                        },
                    });

                    // 自動再生有無を設定
                    this.doAutoPlay(this.isAutoPlay);
                    this.$emit('init', this.sw);

                    // スライドのクリックイベント(親の呼び出し)
                    let self = this;
                    this.swiperWrapper[0].addEventListener("click", function () {
                        self.$emit('clickslide', self.sw.realIndex);
                    });

                    // スライド切り替えイベント(親の呼び出し)
                    this.sw.on('slideChange', function () {
                        self.$emit('changeslide', self.sw.realIndex);
                    })
                }
            }

            // PC/SPフラグ保持
            this.isSp = isSp;
        },

        /**
         * 自動再生の開始・ストップ
         * @param {boolean} isAuto 
         */
        doAutoPlay: function (isAuto) {
            if (isAuto) {
                this.sw.autoplay.start();
            } else {
                this.sw.autoplay.stop();
            }
        }
    },
});
